import {Event} from 'gamesis-story-client';

export class TimelineEvent {
    public type: string;
    public id?: string;
    public event?: Event;
    public count: number;
}
